import type { Id } from "@convex/_generated/dataModel";
import type { AddressValue } from "@/components/inputs/address-input";
import type { FulfillmentType } from "@/components/quotes/listing-request/fulfillment-field";

export interface GuestContactState {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export type QuoteContactMode = "guest" | "account-profile" | "account";

export interface ListingRequestSummary {
  leadId: Id<"leads">;
  leadNumber: string;
  canCancel?: boolean;
}

export interface QuoteFormState {
  contact: GuestContactState;
  quantity: number;
  quantityDisplay: string;
  fulfillmentType: FulfillmentType;
  preferredDate: string;
  datePickerOpen: boolean;
  notes: string;
  submittedLeadNumber: string | null;
  existingRequest: ListingRequestSummary | null;
  submitAttempted: boolean;
  deliveryAddress: AddressValue;
}

export type UpdateQuoteFormState = (patch: Partial<QuoteFormState>) => void;

interface InitialQuoteFormValues {
  initialQuantity: number;
  initialLine1?: string;
  initialLine2?: string;
  initialCity?: string;
  initialState?: string;
  initialZip?: string;
  initialCountry?: string;
  initialDeliveryDate?: string;
  initialContact?: Partial<GuestContactState>;
}

export function buildInitialQuoteFormState(
  values: InitialQuoteFormValues,
): QuoteFormState {
  return {
    contact: {
      firstName: values.initialContact?.firstName ?? "",
      lastName: values.initialContact?.lastName ?? "",
      email: values.initialContact?.email ?? "",
      phone: values.initialContact?.phone ?? "",
    },
    quantity: values.initialQuantity,
    quantityDisplay: String(values.initialQuantity),
    fulfillmentType: "delivery",
    preferredDate: values.initialDeliveryDate ?? "",
    datePickerOpen: false,
    notes: "",
    submittedLeadNumber: null,
    existingRequest: null,
    submitAttempted: false,
    deliveryAddress: {
      line1: values.initialLine1 ?? "",
      line2: values.initialLine2 ?? "",
      city: values.initialCity ?? "",
      state: values.initialState ?? "",
      postalCode: values.initialZip ?? "",
      country: values.initialCountry ?? "US",
    },
  };
}
